var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.81 12.22c1.03-.92 1.69-2.24 1.69-3.72 0-2.76-2.24-5-5-5s-5 2.24-5 5c0 1.49.66 2.81 1.69 3.72-2.76 1.27-4.69 4.05-4.69 7.28 0 .55.45 1 1 1s1-.45 1-1c0-3.31 2.69-6 6-6s6 2.69 6 6c0 .55.45 1 1 1s1-.45 1-1c0-3.23-1.93-6.01-4.69-7.28ZM9.5 8.5c0-1.65 1.35-3 3-3s3 1.35 3 3-1.35 3-3 3-3-1.35-3-3Z"
  })));
};
export default SvgPerson;